import { Permission } from '../../enums';
import { MenuItem } from '../../interfaces';

export const menuItems: MenuItem[] = [
    {
        title: 'Home',
        icon: 'home',
        link: '/home',
        permissions: [Permission.Home],
    },
    {
        title: 'Cash-in/Cash-out',
        icon: 'wallet-money',
        link: '/cash',
        permissions: [Permission.Home], // TODO: ask about which permission to add here
    },
    {
        title: 'Send Money',
        icon: 'send-money',
        link: 'send-money',
        permissions: [Permission.Home],
    },
    {
      title: 'Bill Payment',
      icon: 'bill-payment',
      link: 'bill-payment',
      permissions: [Permission.Home],
    },
];
